import styles from './form.module.scss';
import { FC, useState } from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import { config, defaults, FormValues } from '@components/shared/forms/leadmagnet-form/form.config';
import { Spinner } from '@components/shared/miscellaneous/spinner/spinner';
import Grecaptcha from '@libs/integrations/grecaptcha';
import { FormSuccess } from '@components/shared/miscellaneous/form-success/form-success';
import { LeadMagnetStories } from '@models/leadmagnet.types';
import { createLeadMagnet } from '@services/leadmagnet.service';

type LeadMagnetsFormProps = {
  story: LeadMagnetStories;
  title?: string;
  className?: string;
  buttonLabel?: string;
};

const LeadMagnetsForm: FC<LeadMagnetsFormProps> = ({
  story,
  title = defaults.title,
  className = defaults.className,
  buttonLabel = defaults.buttonLabel,
}) => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const onAfterSubmit = (success: boolean, actions: FormikHelpers<FormValues>): void => {
    actions.setSubmitting(false);
    actions.resetForm();
    setIsSubmitted(success);
  };

  // todo: error handling and error message
  const submitHandler = async (values: FormValues, actions: FormikHelpers<FormValues>) => {
    try {
      actions.setSubmitting(true);
      await createLeadMagnet({ story, ...values });
      onAfterSubmit(true, actions);
    } catch {
      onAfterSubmit(false, actions);
    }
  };

  return (
    <div className={`${styles.container} ${className}`}>
      {
        <>
          <Grecaptcha />
          <Formik onSubmit={submitHandler} {...config}>
            {(formik) => (
              <Form className={`${className} ${styles.form}`}>
                <h3 className={styles.form__title}>{title}</h3>
                <div className={styles.form__field}>
                  <label htmlFor="firstName" className={styles.required}>
                    First name
                  </label>
                  <input
                    id="firstName"
                    type="text"
                    placeholder="Your first name"
                    {...formik.getFieldProps('firstName')}
                  />
                  {formik.touched.firstName && formik.errors.firstName ? (
                    <span className={styles.form__field_error}>{formik.errors.firstName}</span>
                  ) : (
                    ''
                  )}
                </div>
                <div className={styles.form__field}>
                  <label htmlFor="lastName" className={styles.required}>
                    Last name
                  </label>
                  <input id="lastName" type="text" placeholder="Your last name" {...formik.getFieldProps('lastName')} />
                  {formik.touched.lastName && formik.errors.lastName ? (
                    <span className={styles.form__field_error}>{formik.errors.lastName}</span>
                  ) : (
                    ''
                  )}
                </div>
                <div className={styles.form__field}>
                  <label htmlFor="email" className={styles.required}>
                    Email
                  </label>
                  <input id="email" type="text" placeholder="your@email.com" {...formik.getFieldProps('email')} />
                  {formik.touched.email && formik.errors.email ? (
                    <span className={styles.form__field_error}>{formik.errors.email}</span>
                  ) : (
                    ''
                  )}
                </div>
                <div className={styles.form__field}>
                  <label htmlFor="company">Company</label>
                  <input id="company" type="text" placeholder="Your company" {...formik.getFieldProps('company')} />
                </div>
                <button type="submit" className={styles.form__button}>
                  {buttonLabel}
                </button>
                {formik.isSubmitting ? <Spinner className={styles.preloader} /> : ''}
                {isSubmitted ? (
                  <FormSuccess
                    title={'Done!'}
                    text={'Thank you for filling out the form. Please, check your email for the file!'}
                    className={styles.success}
                  />
                ) : (
                  ''
                )}
              </Form>
            )}
          </Formik>
        </>
      }
    </div>
  );
};

export default LeadMagnetsForm;
